import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import * as notification from "./ducks/notification.duck";
import * as unit from "./ducks/unit.duck";

export const rootReducer = combineReducers({
    auth: auth.reducer,
    notification: notification.reducer,
    unit: unit.reducer,
});

export function* rootSaga() {
    yield all([auth.saga()]);
}
